import { Component, ReactNode } from "react"

import PolizzaAttiva from "../insurance/PolizzaAttiva"
import RilevanzaPolizza, { RilevanzaType } from "../insurance/RilevanzaPolizza"
import SiNo, { getSiNoValue } from "../siNo/SiNo"

interface CommonsPolicyProps {
    altriSinistri: boolean | undefined
    altriSinistriError: string | undefined
    updateAltriSinistri: Function

    polizzaAttiva: boolean | undefined
    polizzaAttivaError: string | undefined
    updatePloizzaAttiva: Function

    scadenzaPolizza: string | undefined
    scadenzaPolizzaError: string | undefined
    updateScadenzaPolizza: Function

    rilevanza?: RilevanzaType
    rilevanzaErrro?: string | undefined
    updateRilevanza?: Function

    hideAltriSinistri?: boolean
}

class CommonsPolicyFields extends Component<CommonsPolicyProps> {

    render(): ReactNode {
        return (
            <>
                { this.props.rilevanza && this.props.updateRilevanza &&
                    <div className="col-12">
                        <RilevanzaPolizza 
                            prezzo={ this.props.rilevanza.prezzo }
                            franchigia={ this.props.rilevanza.franchigia }
                            massimale={ this.props.rilevanza.massimale }
                            completezza={ this.props.rilevanza.completezza }
                            flagAltro={ this.props.rilevanza.flagAltro }
                            altro={ this.props.rilevanza.altro }
                            error={ this.props.rilevanzaErrro }
                            callBack={ this.props.updateRilevanza }
                        />
                    </div>
                }

                { this.props.hideAltriSinistri !== true &&
                    <div className='col-12'>
                        <SiNo 
                            label='Hai mai avuto sinistri per questo tipo di assicurazione?'
                            id='altriSinistri'
                            value={ getSiNoValue(this.props.altriSinistri) }
                            callback={this.props.updateAltriSinistri}
                            error={this.props.altriSinistriError}
                        />
                    </div>
                }
                <PolizzaAttiva 
                    siNoValue={ getSiNoValue(this.props.polizzaAttiva) }
                    siNoId='polizzaAttiva'
                    siNoLabel='Hai già una polizza attiva?'
                    siNoCallBack={this.props.updatePloizzaAttiva}
                    errorAttiva={this.props.polizzaAttivaError}

                    dataValue={this.props.scadenzaPolizza}
                    dataId='scadenzaPolizza'
                    dataLabel='Data di scadenza della polizza attiva'
                    dataCallBack={this.props.updateScadenzaPolizza}
                    errorScadenza={this.props.scadenzaPolizzaError}
                />
            </>
        )
    }
}

export default CommonsPolicyFields